import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

/** Group summary returned by `GET /users/:id/groups`. */
export interface UserGroupSummary {
  id: string;
  name: string;
  memberCount: number;
}

/**
 * Fetch the groups a user belongs to. The backend resolves the user's
 * tenant-scoped membership and returns the groups that membership is a
 * member of, shaped as the groups list-item summary.
 */
export function useUserGroups(userId: string | undefined) {
  return useApiQuery<UserGroupSummary[]>({
    queryKey: settingsKeys.userGroups(userId ?? ''),
    queryFn: () =>
      apiGet<UserGroupSummary[]>(operationsClient, settingsEndpoints.userGroups(userId!)),
    enabled: !!userId,
    showErrorToast: false,
  });
}
